import React from 'react';
import { styled } from '@mui/system';

const Container = styled('div')(({ theme }) => ({
  margin: '20px 24px',
  [theme.breakpoints.down('sm')]: {
    margin: '12px'
  },
  '& .breadcrumb': {
    marginBottom: '15px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0px'
    }
  }
}));

const ContainerBody = ({ children }) => {
  // .page-body: hook for the shared list/page styling in assets/css/modern.css
  return <Container className="page-body">{children}</Container>;
};

export default ContainerBody;
